import React, { useState } from "react";
import { AddFlex, CustomText, Gap } from "../reusableStyles";
import { Checkbox, Select } from "antd";
import InstagramContactsStats from "../Integrations/Instagram/InstagramContactsStats";
import { primaryActionColor, primaryActionColorLight } from "../constants";
import {
  BarChartRounded,
  Mail,
  PersonAddRounded,
  Phone,
  QuestionAnswerOutlined,
} from "@mui/icons-material";

function CampaginContacts() {
  const [selectedPaticipant, setSelectedParticipant] = useState("all");
  const [participants, setParticipants] = useState([
    { label: "All Participants", value: "all" },
    { label: "@soishoshank", value: "soishoshank" },
    { label: "@vellankibharadwaj", value: "bharadwaj" },
  ]);
  return (
    <AddFlex flexDirection="column" padding="0 48px">
      <AddFlex>
        <AddFlex gap="20px">
          <AddFlex alignItems="center" gap="5px">
            <Checkbox />
            <CustomText color="black">Feed Posts</CustomText>
          </AddFlex>
          <AddFlex alignItems="center" gap="5px">
            <Checkbox />
            <CustomText color="black">Story Posts</CustomText>
          </AddFlex>
        </AddFlex>
        <Gap />
        <Select
          //   disabled={disabled}
          style={{
            width: "20%",
            margin: "10px auto",
          }}
          value={selectedPaticipant}
          onChange={(username) => {
            setSelectedParticipant(username);
          }}
          options={participants}
          // optionRender={(option) => (
          //   <AddFlex>
          //     {option.data.label}{" "}
          //     <Close
          //       onClick={(e) => {
          //         e.stopPropagation();
          //       }}
          //     />
          //   </AddFlex>
          // )}

          placeholder="Please select"
        />
      </AddFlex>
      <InstagramContactsStats
        isAllContactsView={[]}
        statsCards={[
          {
            name: "Total Comments",
            icon: <QuestionAnswerOutlined style={{ fontSize: "18px" }} />,
            color: primaryActionColor,
            backgroundColor: primaryActionColorLight,
            key: "comments",
          },
          {
            name: "Engaged via shares",
            icon: <QuestionAnswerOutlined style={{ fontSize: "18px" }} />,
            color: primaryActionColor,
            backgroundColor: primaryActionColorLight,
            key: "shares",
          },
          {
            name: "Story Interactions",
            icon: <QuestionAnswerOutlined style={{ fontSize: "18px" }} />,
            color: primaryActionColor,
            backgroundColor: primaryActionColorLight,
            key: "story",
          },
          {
            name: "Fully Engaged Count",
            icon: <BarChartRounded style={{ fontSize: "18px" }} />,
            color: primaryActionColor,
            backgroundColor: primaryActionColorLight,
            key: "end",
          },
          {
            name: "Followers gained",
            icon: <PersonAddRounded style={{ fontSize: "18px" }} />,
            color: "#6A1E55",
            key: "followers",
            backgroundColor: "#6A1E5533",
          },
          {
            name: "E-Mails collected",
            icon: <Mail style={{ fontSize: "18px" }} />,
            color: primaryActionColor,
            key: "email",
            backgroundColor: primaryActionColorLight,
          },
          {
            name: "Numbers collected",
            icon: <Phone style={{ fontSize: "18px" }} />,
            color: "#684EA6",
            key: "phoneNumber",
            backgroundColor: "#E2D9F7",
          },
        ]}
        statsData={[]}
      />
    </AddFlex>
  );
}

export default CampaginContacts;
